"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyList = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const client_1 = require("@rws-framework/client");
const backendImport_1 = require("@front/backendImport");
const component_1 = require("@front/components/site-menu/component");
const component_2 = require("@front/layouts/default-layout/component");
//@ts-ignore                
let rwsTemplate = T.html `<div class="container-fluid">
  <div class="company-list-page">
    <crud-table title="${'route.company.list'.t()}" addText="${'route.company.create'.t()}" resource="company" searchPlaceholder="Search companies..."
      indexEndpoint="company.index" listEndpoint="company.list" deleteEndpoint="company.delete"
      editRoute="/company/edit/:id" addRoute="/company/create" :columns="${x => x.tableColumns}"
      :actions="${x => x.isSuperAdmin ? x.baseActions : []}">
    </crud-table>
  </div>
</div>`;
const styles = null;
const shadowOptions = { "mode": "open" };
let CompanyList = class CompanyList extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.baseActions = [
            {
                key: 'preview',
                icon: 'simple-icon-magnifier',
                label: '',
                variant: 'info',
                tooltip: 'company.tooltips.preview'.t(),
                tooltipDirection: 'left',
                handler: async (id) => {
                    this.previewCompany.bind(this)(id);
                }
            }
        ];
        this.tableColumns = [
            { key: 'name', header: 'company.name'.t() },
            { key: 'nip', header: 'company.nip'.t(), formatter: (value) => value || '-' },
            { key: 'email', header: 'company.email'.t(), formatter: (value) => value || '-' },
            { key: 'phone', header: 'company.phone'.t(), formatter: (value) => value || '-' },
            { key: 'city', header: 'company.city'.t(), formatter: (value) => value || '-' },
            {
                key: 'modules',
                header: 'company.modules'.t(),
                formatter: (modules) => {
                    if (!modules || !modules.length)
                        return '-';
                    return modules.map((module) => `<span class="badge badge-secondary mr-1">${module}</span>`).join('');
                }
            },
            {
                key: 'active',
                header: 'company.active'.t(),
                formatter: (active) => {
                    const status = active ? 'Active' : 'Inactive';
                    const badgeClass = active ? 'success' : 'danger';
                    return `<span class="badge badge-${badgeClass}">${status}</span>`;
                }
            }
        ];
    }
    get isSuperAdmin() {
        return component_2.DefaultLayout.USER.role === backendImport_1.UserRoles.SUPER_ADMIN;
    }
    previewCompany(id) {
        component_1.SiteMenu.goto.bind(this)(`/company/preview/${id}`);
    }
};
exports.CompanyList = CompanyList;
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], CompanyList.prototype, "baseActions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], CompanyList.prototype, "tableColumns", void 0);
exports.CompanyList = CompanyList = __decorate([
    (0, client_1.RWSView)('company-list', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], CompanyList);
CompanyList.defineComponent();
